export default "__VITE_ASSET__7hADtWIw__"